import { User } from "interfaces/user";

export interface UserState {
	userInfo: User | null;
}

export enum UserActionTypes {
	GET_USER = "@@user/GET_USER",
	SET_USER = "@@user/SET_USER",
}

export interface GetUserAction {
	type: UserActionTypes.GET_USER;
}

export interface SetUserAction {
	type: UserActionTypes.SET_USER;
	payload: User | null;
}

export type UserAction = GetUserAction | SetUserAction;
